import { faUser } from "@fortawesome/pro-regular-svg-icons";

import { HistorySingleEntry } from "src/cases/caseView/history/HistoryItemFrame";
import { UserPill } from "src/cases/common/UserPill";
import { CaseHistoryEvent } from "src/cases/queries/casesTypes";

export const CaseAssigned: React.FC<{
  entry: CaseHistoryEvent<"case_assigned">;
  isLast: boolean;
}> = ({ entry, isLast }) => {
  return (
    <HistorySingleEntry
      actorId={entry.event_data.assigned_by_user_id}
      eventType={entry.event_type}
      headline={
        <>
          Case was assigned to{" "}
          <div className="inline-block align-middle">
            <UserPill userId={entry.event_data.assigned_to_user_id} />
          </div>
          .
        </>
      }
      icon={faUser}
      isLast={isLast}
      timestamp={entry.timestamp}
    />
  );
};
